// extracted by mini-css-extract-plugin
export default {"formWrapper":"style_formWrapper__ajYTc","formItemLabel":"style_formItemLabel__4Pyxh","btnSignin":"style_btnSignin__BO3Al"};